import { useEffect, useState } from "react";

// usePersistedState: useState with a localStorage round-trip. Lazy-initializes
// from storage and writes on every change. ``key`` should be unique per page;
// pages already namespace via "bidrl_<page>_<field>" so no further prefixing
// is needed here. ``serialize``/``deserialize`` default to JSON which is fine
// for primitives and plain objects/arrays.
export function usePersistedState(key, defaultValue, opts) {
  const { serialize = JSON.stringify, deserialize = JSON.parse } = opts || {};

  const [value, setValue] = useState(() => {
    if (!key) return defaultValue;
    try {
      const raw = localStorage.getItem(key);
      if (raw === null) return defaultValue;
      return deserialize(raw);
    } catch {
      return defaultValue;
    }
  });

  useEffect(() => {
    if (!key) return;
    try {
      if (value === undefined || value === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, serialize(value));
      }
    } catch { /* quota / privacy mode — non-fatal */ }
  }, [key, value, serialize]);

  return [value, setValue];
}
